import formatTableJson from '@manage/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'model',
    label: '设备型号'
  },
  {
    filed: 'type',
    label: '间室',
    formatFn: function (_, row) {
      let dic = {
        '0018yquwclzb4otl': '一室酒柜',
        '0028yquwclzb4otl': '两室酒柜'
      }
      return dic[row.type]
    }
  },
  {
    filed: 'picture',
    label: '图片',
    type: 'image',
    needPreviewImg: true
  },
  {
    filed: 'remark',
    label: '备注'
  },
  {
    filed: 'row',
    label: '层数'
  },
  {
    filed: 'col',
    label: '列数'
  }
])
